import { FC, useMemo } from 'react';

import { NODE_TYPES, ChannelOptNodeData } from 'modules/workflows';
import { ChannelOptEditor } from './ChannelOptEditor';
import { CHOChannelEditor } from './CHOChannelEditor/CHOChannelEditor';
import { ChannelOptEditorProps } from './types';

const getEditorComponent = (editorType: string) => {
  const editorsByType: Record<string, FC<React.PropsWithChildren<any>>> = {
    [NODE_TYPES.CHANNEL_OPT]: ChannelOptEditor,
    [NODE_TYPES.SEND_EMAIL]: CHOChannelEditor,
    [NODE_TYPES.SEND_PUSH]: CHOChannelEditor,
    [NODE_TYPES.SEND_SMS]: CHOChannelEditor,
  };
  return editorsByType[editorType] ?? null;
};

export const ChannelOptEditorManager: FC<React.PropsWithChildren<ChannelOptEditorProps>> = (
  props,
) => {
  const { nodeData = {} } = props;
  const { selectedEditor = NODE_TYPES.CHANNEL_OPT } = nodeData as ChannelOptNodeData;
  const Editor = useMemo(() => getEditorComponent(selectedEditor), [selectedEditor]);

  return Editor ? <Editor {...props} /> : null;
};
